export default {
  "wrapper": "_wrapper_uaihy_1",
  "image": "_image_uaihy_9",
  "hidden": "_hidden_uaihy_12",
  "placeholder": "_placeholder_uaihy_16"
};import "ni:sha-256;hna82LiEC3n4-BXL6-HY85glfBmW-uWUnYaqiblK320";